<template>

	<v-app>

		<div style="background: #f4f4f4;">
    	
    	<v-container class="mt-5 mb-5" id="terms-condition">

    		<v-row>

    			<v-col offset-lg="2" lg="8">

    				<h2 class="text-center">Términos y condiciones</h2>

    				<div class="mt-5" v-html="terms"></div>

    			</v-col>

    		</v-row>

    	</v-container>

    </div>

	</v-app>

</template>


<script>
	
	import TermsService from '@/shared/services/TermsService'

	export default
	{
		data() {
			return {
				terms: null
			}
		},

		created() {
			this.getTerms()
		},

		methods: {

			async getTerms()
			{
				const resp = await TermsService.get()
				this.terms = resp.data.terms 
			}

		}
	}

</script>